import React, { useEffect, FunctionComponent } from 'react';
import { Redirect, RouteComponentProps, useLocation } from 'react-router-dom';
import { useAppDispatch } from '../../redux/hooks';
import { ROUTES } from '../../routing/routes';

type PropsLocation = {
  location?: RouteComponentProps<{ path: string }, {}, { state: string }>;
};

const RedirectingPage: FunctionComponent<PropsLocation> = props => {
  const dispatch = useAppDispatch();
  const location = useLocation();

  return <Redirect to={ROUTES.HOME} />;
};

export default RedirectingPage;
